@if (state().showTopScrim) {
  <div class="sidebar-scroll-scrim sidebar-scroll-scrim--top" aria-hidden="true"></div>
}

@if (state().showBottomHint) {
  <div class="sidebar-scroll-scrim sidebar-scroll-scrim--bottom" aria-hidden="true"></div>
  <button
    type="button"
    class="sidebar-scroll-chevron"
    [class.sidebar-scroll-chevron--bob]="bobbing()"
    aria-hidden="true"
    tabindex="-1"
    (click)="pageDown.emit()"
    (animationend)="onBobAnimationEnd()"
  >
    <fa-icon [icon]="['far', 'chevron-down']" aria-hidden="true" />
  </button>
}
